module.exports = __webpack_public_path__ + "media/images/gotquestions-0df70d7735e6f1903e049bf841edeca9.jpg";